export default __webpack_public_path__ + "static/media/flag-en.895846e2.svg";